import axios from "axios";
import {useStore} from "@/store";
import router from "@/router";
import {ElNotification} from "element-plus";
import {getHost} from "@/helpers/h2";


// const API_URL = process.env?.VUE_APP_API_URL
const API_URL = getHost() + "/api/"

export async function logout(silent = false) {
	console.log("Bye-bye!")
	let store = useStore()
	await clearUser(store)
	delete axios.defaults.headers.common['Authorization']
	if (!silent) {
		window.dispatchEvent(new Event('session-expired'))
	}

	return router.push("/")
}

export function isAuthenticated(store = null) {
	if(!store) store = useStore()
	return !!(store.getP("customer") || store.getP('access_token'))
}

export async function clearUser(store) {
	store.deleteP('access_token')
	store.deleteP('refresh_token')
	store.deleteP('author')
	store.deleteP('customer')
	localStorage.removeItem('token')
	localStorage.removeItem('dreams_ref')
	localStorage.removeItem('dreams_account_id')
}

export async function updateMe(store) {
	let ret = {}
	const r = await new Back("users/me", 'get').run()
	if(r?.data?.login) {
		store.setP('author', r?.data)
		ret = r?.data
	}
	else await clearUser()
	return ret
}

export function validateCustomer(fieldName, value, store) {
	/**
	 * Валидация Зрителя на разных этапах
	 * - при попадании на страницу платежа
	 * - после оплаты
	 * ...
	 */
	if(!store) store = useStore()
    return new Promise((resolve, reject) => {
        new Back('validate-customer', 'post')
            .setData({ [fieldName]: value })
            .run(r => {
                if (r?.data) {
                    store.setP('customer', r.data)
					if(r?.data?.card_id) localStorage.setItem('token', r?.data?.card_id)
                    resolve(r.data)
                } else {
                    store.deleteP('customer')
					localStorage.removeItem('token')
                    reject(r)
                }
            })
            .catch(err => {
                store.deleteP('customer')
				localStorage.removeItem('token')
                reject(err)
            })
    })
}

/**
 * Новая 20260424 реализация + проще + эмиттер
 * @param value
 * @param emitter
 * @param store
 * @param field
 */
export function validateBy(value, emitter, store, field='account_id') {
	new Back('validate-customer', 'post')
		.setData({[field]: value})
		.run(r => {
			if(r?.data?.account_id) {
				store.setP('customer', r.data)
				localStorage.setItem('dreams_account_id', r.data.account_id)

				emitter.emit('validateBy', {
					'dreams_account_id': r.data.account_id,
					'phone': r.data?.phone,
					'valid': r.data?.valid
				})
			} else emitter.emit('validateBy', null)
		})
}


export class Back {
	constructor(endpoint, method = "get") {
		this.store = useStore()
		this.endpoint = endpoint
		this.data = null
		this.method = method
		this.loading_key = "loading"
	}

	setData(data) {
		this.data = data
		return this
	}

	setLoadingKey(loading_key) {
		this.loading_key = loading_key
		return this
	}

	run(callback = null) {
		this.store.setLoading(this.loading_key)

		let isRefreshing = false;
		let failedQueue = [];

		let api = axios.create({
			baseURL: API_URL,
  			headers: { 'Content-Type': 'application/json' },
		})

		const processQueue = (error, token = null) => {
			failedQueue.forEach(prom => {
				error ? prom.reject(error) : prom.resolve(token);
			});
			failedQueue = [];
		}

		// Передаю access_token
		api.interceptors.request.use(config => {
			const token = this.store.getP('access_token');
			if (token)  config.headers['Authorization'] = 'Bearer ' + token;
			return config;
		});

		// перехват 401 и удаление токенов и обновление access token
		api.interceptors.response.use(
			response => {
				this.store.setLoaded(this.loading_key)
				return response
			},

			async error => {
				const originalRequest = error.config;

				// todo: как то криво и не красиво все !!!!!
				if (
					error?.response &&
					[400, 404, 403, 503].includes(error.response?.status)
				) {
					this.store.addMessage(error.response?.data?.detail)
					isRefreshing = false;
					this.store.setLoaded(this.loading_key)
					return Promise.resolve(error);
				}

				// Если ошибка 401 и не повторяемая
				else if (
					error?.response &&
					error.response?.status === 401 &&
					!originalRequest._retry
				) {
					if (isRefreshing) {

						// Ждём обновление
						return new Promise(function (resolve, reject) {
							failedQueue.push({resolve, reject});
						})
							.then(token => {
								originalRequest.headers['Authorization'] = 'Bearer ' + token;
								return api(originalRequest);
							})
							.catch(err => {
								return Promise.reject(err);
							})
							.finally(_ => {
								this.store.setLoaded(this.loading_key)
							})
					}

					originalRequest._retry = true;
					isRefreshing = true;

					try {
						const refreshToken = this.store.getP('refresh_token');

						const res = await axios.post(`${API_URL}users/refresh`, {
							token: refreshToken,
						});

						const newAccessToken = res.data.access_token;
						this.store.setP('access_token', newAccessToken);
						api.defaults.headers.common['Authorization'] = 'Bearer ' + newAccessToken;
						processQueue(null, newAccessToken);

						originalRequest.headers['Authorization'] = 'Bearer ' + newAccessToken;
						return api(originalRequest);

					} catch (err) {
						processQueue(err, null);
						this.store.deleteP('access_token');
						this.store.deleteP('refresh_token');
						window.location.href = '/login'; // или emit logout
						return Promise.reject(err);
					} finally {
						isRefreshing = false;
					}
				}

				if (error?.response) {
					let msg = `Error ${error} ${error.response?.status} ${error.response?.message}`
					this.store.addMessage(msg)
				}
				else if(error?.message) {
					let msg = `Error ${error?.message}`
					this.store.addMessage(msg)
				}

				this.store.setLoaded(this.loading_key)
				return callback ? callback(error) : Promise.reject(error);
			}
		)

		// нужно передать только эндпоинт
		let args = {
			url: `${API_URL}${this.endpoint}`,
			method: this.method,
		}

		// Чтобы не запрашивать null
		let data = this.data ? {...this.data} : {} // чтобы при чистке null не реактивить
		// данные
		for (let k in data) {
			if (data[k] === null) delete data[k]
			if (data[k] === 'null') data[k] = null // чтобы сбрасывать значения
		}
		args[this.method === 'get' ? 'params' : 'data'] = data

		// универсальный запрос
		try {
			let promise = api.request(args)
			return callback ? promise.then(callback) : promise
		} catch (error) {
			return callback ? Promise.reject(error).then(callback) : Promise.reject(error)
		}

	}
}